<template>
	<c-dialog ref="dialog" :title="title" width="520" height="615" enable-flex :button="false">
		<div class="share-dialog-content">
			<!-- 分享开关 -->
			<div class="share-switch-box flex-center-cross">
				<span class="switch-label">分享开关</span>
				<c-switch v-model="shareEnabled" @change="shareSwitchChange"></c-switch>
			</div>

			<!-- 分享已关闭提示 -->
			<div v-if="!shareEnabled" class="share-closed-tip">
				<p>分享已关闭，开启后可生成分享链接</p>
			</div>

			<!-- 分享内容 -->
			<template v-else>
				<!-- 分享链接地址 -->
				<div class="share-item">
					<label class="share-label">分享链接地址</label>
					<div class="share-link-box">
						<div class="share-link-text">{{ shareUrl }}</div>
						<div class="share-link-action">
							<c-link @click="copyAllInfo" class="copy-all-btn">
								<i class="tf-copy"></i> 复制全部链接
							</c-link>
						</div>
					</div>
				</div>

				<!-- 密码保护 -->
				<div class="share-item">
					<div class="password-row flex-center-cross">
						<c-checkbox v-model="isPasswordProtected" @change="passwordChangeHandle">
							密码保护
						</c-checkbox>
						<div v-if="isPasswordProtected" class="password-info flex-center-cross">
							<div class="password-tag">{{ password }}</div>
							<c-link @click="refreshPassword" class="refresh-link">
								<i class="tf-refresh"></i> 随机生成
							</c-link>
						</div>
					</div>
				</div>

				<!-- 二维码展示 -->
				<div class="share-qrcode-box flex-center">
					<div class="qrcode-card">
						<p class="qrcode-factory">{{ saasName || '机老大管家' }}</p>
						<p class="qrcode-work">{{ qrTitle }}</p>
						<canvas ref="qrcodeCanvas" width="180" height="180" class="share-qrcode"></canvas>
						<p class="qrcode-tip">扫码查看</p>
						<div class="qrcode-download">
							<c-button prepend-icon="tf-download" color="main" size="small" @click="downloadQrcode">下载二维码</c-button>
						</div>
					</div>
				</div>
			</template>
		</div>
	</c-dialog>
</template>

<script>
	import { mapState } from 'vuex'
	import QRCode from 'qrcode'

	export default {
		name: 'shareDialog',

		data() {
			return {
				workType: 0,
				workId: 0,
				workCode: '',
				title: '',				//弹框标题
				qrTitle: '',			//二维码标题
				shareLikeTitle: '',		//分享链接标题
				shareUrl: '',
				token: '',
				password: '',
				isPasswordProtected: true,
				shareEnabled: false
			}
		},

		computed: {
			...mapState(['saasInfo', 'systemConfig']),
			saasName() {
				return this.saasInfo ? this.saasInfo.saas_name : ''
			}
		},

		methods: {
			open(data) {
				this.resetShareData();
				this.workType = data.workType;
				this.workId = data.workId;
				this.workCode = data.workCode;
				this.title = data.title;
				this.qrTitle = data.qrTitle;
				this.shareLikeTitle = data.shareLikeTitle;
				this.queryStatus();
				this.$refs.dialog.open();
			},

			// 查询分享状态
			queryStatus() {
				this.request({
					url: '/share/status',
					data: {
						work_type_id: this.workType,
						work_id: this.workId
					},
					loading: true,
					success: data => {
						if (data) {
							this.shareEnabled = true
							this.token = data.token
							this.isPasswordProtected = data.isPasswordProtected == 1
							this.password = data.password || ''
							this.buildShareUrl()
							this.$nextTick(() => {
								this.renderQrcode()
							})
						} else {
							this.shareEnabled = false
							this.resetShareData()
						}
					}
				})
			},

			// 分享开关变化
			shareSwitchChange(val) {
				if (val) {
					// 开启分享
					this.request({
						url: '/share/createOrGet',
						data: {
							work_type_id: this.workType,
							work_id: this.workId
						},
						loading: true,
						success: data => {
							this.token = data.token
							this.isPasswordProtected = data.isPasswordProtected == 1
							this.password = data.password || ''
							this.buildShareUrl()
							this.$nextTick(() => {
								this.renderQrcode()
							})
							this.$message({
								message: '分享已开启',
								type: 'success'
							})
						}
					})
				} else {
					// 关闭分享
					if (!this.token) {
						this.resetShareData()
						return
					}
					this.request({
						url: '/share/close',
						data: { token: this.token },
						loading: true,
						success: () => {
							this.resetShareData()
							this.$message({
								message: '分享已关闭',
								type: 'success'
							})
						}
					})
				}
			},

			// 重置分享数据
			resetShareData() {
				this.shareEnabled = false;
				this.token = '';
				this.shareUrl = '';
				this.password = '';
				this.isPasswordProtected = true;
			},

			// 构造分享链接
			buildShareUrl() {
				const host = window.location.host
				const protocol = window.location.protocol
				this.shareUrl = this.systemConfig.system_h5_url + `share/work?token=${this.token}`
			},

			// 渲染二维码到 canvas
			renderQrcode() {
				if (!this.shareUrl || !this.$refs.qrcodeCanvas) return
				QRCode.toCanvas(this.$refs.qrcodeCanvas, this.shareUrl, {
					width: 180,
					margin: 2
				}, (err) => {
					if (err) console.error('二维码生成失败', err)
				})
			},

			// 下载二维码图片
			downloadQrcode() {
				const canvas = document.createElement('canvas')
				const ctx = canvas.getContext('2d')
				const width = 300
				const height = 380
				canvas.width = width
				canvas.height = height

				// 白色背景
				ctx.fillStyle = '#ffffff'
				ctx.fillRect(0, 0, width, height)

				// 商户名
				ctx.fillStyle = '#00b578'
				ctx.font = 'bold 20px Arial'
				ctx.textAlign = 'center'
				ctx.fillText(this.saasName || '机老大管家', width / 2, 45)

				// 二维码标题
				ctx.fillStyle = '#666666'
				ctx.font = '14px Arial'
				ctx.fillText(`${this.qrTitle}`, width / 2, 75)

				// 二维码
				const sourceCanvas = this.$refs.qrcodeCanvas
				if (sourceCanvas) {
					ctx.drawImage(sourceCanvas, (width - 180) / 2, 95, 180, 180)
				}

				// 提示文字
				ctx.fillStyle = '#999999'
				ctx.font = '12px Arial'
				ctx.fillText('扫码查看', width / 2, 305)

				// 下载
				const link = document.createElement('a')
				link.download = `分享-${this.workCode}.png`
				link.href = canvas.toDataURL('image/png')
				link.click()
			},

			// 密码保护开关变化
			passwordChangeHandle(val) {
				const isProtected = val ? 1 : 0
				if (isProtected && !this.password) {
					this.password = this.generateRandomPassword()
				}
				this.request({
					url: '/share/update',
					data: {
						token: this.token,
						is_password_protected: isProtected,
						password: this.password
					}
				})
			},

			// 生成随机密码
			generateRandomPassword() {
				const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
				let pwd = ''
				for (let i = 0; i < 4; i++) {
					pwd += chars.charAt(Math.floor(Math.random() * chars.length))
				}
				return pwd
			},

			// 随机生成密码
			refreshPassword() {
				this.password = this.generateRandomPassword()
				this.request({
					url: '/share/update',
					data: {
						token: this.token,
						is_password_protected: 1,
						password: this.password
					},
					success: () => {
						this.$message({
							message: '密码已重新生成',
							type: 'success'
						})
					}
				})
			},

			// 复制全部信息
			copyAllInfo() {
				let text = `${this.shareLikeTitle}${this.shareUrl}`
				if (this.isPasswordProtected) {
					text += `\n访问密码：${this.password}`
				}
				const textarea = document.createElement('textarea')
				textarea.value = text
				document.body.appendChild(textarea)
				textarea.select()
				document.execCommand('copy')
				document.body.removeChild(textarea)
				this.$message({
					message: '全部信息已复制到剪贴板',
					type: 'success'
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.share-dialog-content {
		padding: 10px 10px;
	}

	.share-switch-box {
		margin-bottom: 20px;
		padding: 15px;
		background-color: #f8f8f8;
		border-radius: 8px;
	}

	.switch-label {
		font-size: 14px;
		font-weight: bold;
		color: #333;
		margin-right: 15px;
	}

	.share-closed-tip {
		padding: 40px 20px;
		text-align: center;
		color: #999;
		font-size: 14px;
	}

	.share-item {
		margin-bottom: 20px;
	}

	.share-label {
		display: block;
		margin-bottom: 8px;
		font-size: 14px;
		color: #333;
	}

	.share-link-box {
		padding: 10px 12px;
		background-color: #f5f5f5;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}

	.share-link-text {
		font-size: 13px;
		color: #666;
		line-height: 1.6;
		word-break: break-all;
		white-space: normal;
	}

	.share-link-action {
		margin-top: 8px;
		padding-top: 8px;
		border-top: 1px dashed #ddd;
		text-align: right;
	}

	.copy-link-btn {
		font-size: 13px;
		margin-right: 15px;

		i {
			margin-right: 3px;
		}
	}

	.copy-all-btn {
		font-size: 13px;

		i {
			margin-right: 3px;
		}
	}

	.password-row {
		height: 32px;
	}

	.password-info {
		margin-left: 12px;
		display: flex;
		align-items: center;
	}

	.password-tag {
		display: inline-block;
		padding: 2px 10px;
		background-color: #00b578;
		color: #fff;
		font-size: 14px;
		font-weight: bold;
		font-family: 'Courier New', monospace;
		letter-spacing: 4px;
		border-radius: 4px;
		margin-right: 10px;
		line-height: 1.4;
	}

	.refresh-link {
		font-size: 13px;

		i {
			margin-right: 3px;
		}
	}

	.share-qrcode-box {
		margin-top: 15px;
		padding: 20px;
		background-color: #f8f8f8;
		border-radius: 8px;
	}

	.qrcode-card {
		text-align: center;
	}

	.qrcode-factory {
		font-size: 16px;
		font-weight: bold;
		color: #00b578;
		margin-bottom: 5px;
	}

	.qrcode-work {
		font-size: 13px;
		color: #666;
		margin-bottom: 15px;
	}

	.share-qrcode {
		margin-bottom: 10px;
	}

	.qrcode-tip {
		font-size: 12px;
		color: #999;
		margin-bottom: 12px;
	}

	.qrcode-download {
		margin-top: 5px;
	}
</style>
